import { useEffect, useState } from 'react';
import {editarUsuarioConsultante,ingresarUsuarioConsultante,obtenerUsuarioConsultante,obtenerSecciones,
    obtenerCamposPorConsultante,obtenerArchivosSubidosFicha,subirArchivoFicha,obtenerArchivoFicha,eliminarArchivoFicha,
    obtenerSesionesPorConsultante,obtenerUsuariosTerapeutasOcupacionales,
    obtenerUsuariosPsicologas,obtenerUsuariosOtros, ingresarSesion,eliminarSesion,ingresarParticipacionGrupal,
    eliminarParticipacionGrupal,obtenerParticipacionesGrupalesPorConsultante} from '../data/FichaConsultante';
import { useContext } from "react";
import { AuthContext } from "auth";

export const useFichaConsultante = (Usuario) => {
    var {user}= useContext(AuthContext)
    const [respuestaServicio, setRespuestaServicio] = useState({mensajeTexto:"",estado:false});
    const [usuarioConsultante, setUsuarioConsultante] = useState(Usuario);
    const [actualizarFichaElementoCompleto, setActualizarFichaElementoCompleto] = useState([]);
    const [actualizarFicha, setActualizarFicha] = useState({});
    const [secciones, setSecciones] = useState();
    const [campos, setCampos] = useState();
    const [archivosFicha,setArchivosFicha]=useState();
    const [respuestaSubidaArchivo, setRespuestaSubidaArchivo] = useState({mensajeTexto:"",estado:false});
    const [sesionesFicha,setSesionesFicha]=useState();
    const [participacionGrupalFicha,setParticipacionGrupalFicha]=useState();
    const [usuariosTo,setUsuariosTo]=useState();
    const [usuariosSicologas,setUsuariosSicologas]=useState();
    const [usuariosOtros,setUsuariosOtros]=useState();
    const [respuestaIngresoSesion, setRespuestaIngresoSesion] = useState({mensajeTexto:"",estado:false});
    const [respuestaIngresoParticipacionGrupal, setRespuestaIngresoParticipacionGrupal] = useState({mensajeTexto:"",estado:false});

    const getSecciones= async()=>{
        if(usuarioConsultante?.Id!=undefined && usuarioConsultante?.Id!='' ){
            const secciones = await obtenerSecciones(usuarioConsultante.Id,user.Token);
            setSecciones(secciones);
        }
    }
    const getCampos= async()=>{
        if(usuarioConsultante?.Id!=undefined && usuarioConsultante?.Id!='' ){
        const campos = await obtenerCamposPorConsultante(usuarioConsultante.Id,user.Token);
        setCampos(campos);
        
        }
    }
    const getUsuarioConsultante = async() => {
        if(usuarioConsultante?.Id!=undefined && usuarioConsultante?.Id!='' ){
            const usuario = await obtenerUsuarioConsultante(usuarioConsultante.Id,user.Token);
            setUsuarioConsultante(usuario);
        }
    }
    const updateRespuestaActualizarFicha=async(Estado,Texto) =>{
        setTimeout(function() {
            setRespuestaServicio({mensajeTexto:Texto,estado:Estado});
        }, 4000);
    }
    const updateUsuarioConsultante = async() => {
       if(actualizarFicha!={})
       {
            let elementosCompletos={};
            if(actualizarFichaElementoCompleto!={}){
                
                elementosCompletos=actualizarFichaElementoCompleto;
            }
            const respuesta= await editarUsuarioConsultante(usuarioConsultante.Id,actualizarFicha,elementosCompletos,user.Token);
            setRespuestaServicio({estado:respuesta.success,mensajeTexto:respuesta.message})
            //updateRespuestaActualizarFicha(respuesta.success,respuesta.message);
            if(respuesta.success){
                setActualizarFicha({});
            }
            //updateRespuestaActualizarFicha(respuesta.success,respuesta.message);
        }
    }
    const createUsuarioConsultante = async() => {
        const respuesta=await ingresarUsuarioConsultante(usuarioConsultante,user.Token);
        if(typeof respuesta.message !== 'string')
        {
            setRespuestaServicio({estado:respuesta.success,mensajeTexto:'Se produjo un error'});
        }
        else
        {
            setRespuestaServicio({estado:respuesta.success,mensajeTexto:respuesta.message});
        }        
    }
    const getArchivosFicha = async() => {
        if(usuarioConsultante?.Id!=undefined && usuarioConsultante?.Id!='' ){
            const respuesta=await obtenerArchivosSubidosFicha(usuarioConsultante,user.Token);
            setArchivosFicha(respuesta)
        }
    }
    const loadArchivoFicha=async(Archivo,Descripcion) =>{
        if(usuarioConsultante?.Id!=undefined && usuarioConsultante?.Id!='' && Archivo!=undefined ){
            const respuesta=await subirArchivoFicha(usuarioConsultante.Id,Archivo,Descripcion,user.Token);
           
            setRespuestaSubidaArchivo({estado:respuesta.success,mensajeTexto:respuesta.message})
            return respuesta;
        }
    }
    const getArchivoFicha = async(ArchivoId) => {
        if(usuarioConsultante?.Id!=undefined && usuarioConsultante?.Id!='' && ArchivoId!=undefined ){
            const respuesta=await obtenerArchivoFicha(usuarioConsultante,ArchivoId,user.Token);
            return respuesta;
        }
    }
    const updateRespuestaSubir = async() => {
        setTimeout(function() {
            setRespuestaSubidaArchivo({mensajeTexto:"",estado:false});
        }, 4000);
        
    }
    
    const deleteArchivoFicha=async(ArchivoId) =>{
        if(usuarioConsultante?.Id!=undefined && usuarioConsultante?.Id!='' && ArchivoId!=undefined ){
            const respuesta=await eliminarArchivoFicha(usuarioConsultante.Id,ArchivoId,user.Token);
            setRespuestaSubidaArchivo({estado:respuesta.success,mensajeTexto:respuesta.message})
            return respuesta;
        }
    }
      
    const getUsuariosTerapeutasOcupacionales= async() => {
        const respuesta=await obtenerUsuariosTerapeutasOcupacionales(user.Token);
        setUsuariosTo(respuesta)
    }
    const getUsuariosPsicologas= async() => {
        const respuesta=await obtenerUsuariosPsicologas(user.Token);
        setUsuariosSicologas(respuesta)
    }
    const getUsuariosOtros= async() => {
        const respuesta=await obtenerUsuariosOtros(user.Token);
        setUsuariosOtros(respuesta)
    }   
    const insertSesion=async(SesionPorAgregar)=>{
        if(SesionPorAgregar!=null){
            SesionPorAgregar.ConsultanteId=usuarioConsultante.Id;
            const respuesta=await ingresarSesion(SesionPorAgregar,user.Token);
            setRespuestaIngresoSesion({estado:respuesta.success,mensajeTexto:respuesta.message})
            return respuesta;
        }
    }
    const deleteFichaConsultanteSesion=async(SesionId)=>{
        if(SesionId!=null && SesionId!=undefined){
            const data={
                ConsultanteId:usuarioConsultante.Id,
                SesionId:SesionId
            }
            const respuesta=await eliminarSesion(data,user.Token);
            //setRespuestaIngresoSesion({estado:respuesta.success,mensajeTexto:respuesta.message})
            return respuesta;
        }
    }
    const getSesionesPorConsultante = async() => {
       
        if(usuarioConsultante?.Id!=undefined && usuarioConsultante?.Id!='' ){
            const respuesta=await obtenerSesionesPorConsultante(usuarioConsultante.Id,user.Token);
            setSesionesFicha(respuesta)
            return respuesta;
        }
    }
    const updateRespuestaIngresoSesion=async =>{
        setTimeout(function() {
            setRespuestaIngresoSesion({mensajeTexto:"",estado:false});
        }, 4000);
    }
    const insertParticipacionGrupal=async(ParticipacionGrupalPorAgregar)=>{
        if(ParticipacionGrupalPorAgregar!=null){
            ParticipacionGrupalPorAgregar.ConsultanteId=usuarioConsultante.Id;
            const respuesta=await ingresarParticipacionGrupal(ParticipacionGrupalPorAgregar,user.Token);
            setRespuestaIngresoParticipacionGrupal({estado:respuesta.success,mensajeTexto:respuesta.message})
            return respuesta;
        }
    }
    const deleteFichaConsultanteParticipacionGrupal=async(ParticipacionGrupalId)=>{
        if(ParticipacionGrupalId!=null && ParticipacionGrupalId!=undefined){
            const data={
                ConsultanteId:usuarioConsultante.Id,
                ParticipacionGrupalId:ParticipacionGrupalId
            }
            const respuesta=await eliminarParticipacionGrupal(data,user.Token);
            return respuesta;
        }
    }
    const getParticipacionGrupalPorConsultante = async() => {
       
        if(usuarioConsultante?.Id!=undefined && usuarioConsultante?.Id!='' ){
            const respuesta=await obtenerParticipacionesGrupalesPorConsultante(usuarioConsultante.Id,user.Token);
            setParticipacionGrupalFicha(respuesta)
            return respuesta;
        }
    }
    const updateRespuestaIngresoParticipacionGrupal=async =>{
        setTimeout(function() {
            setRespuestaIngresoParticipacionGrupal({mensajeTexto:"",estado:false});
        }, 4000);
    }
    useEffect( () => {
        async function setFichaConsultanteFuncion() {
            getUsuarioConsultante();
            getSecciones();
            getCampos();
        }
        setFichaConsultanteFuncion();

    }, []);

    return {
        usuarioConsultante,
        secciones,
        campos,
        setUsuarioConsultante,
        updateUsuarioConsultante,
        createUsuarioConsultante,
        respuestaServicio,
        updateRespuestaActualizarFicha,
        archivosFicha,
        getArchivosFicha,
        loadArchivoFicha,
        getArchivoFicha,
        respuestaSubidaArchivo,
        updateRespuestaSubir,
        deleteArchivoFicha,
        actualizarFicha,
        setActualizarFicha,
        actualizarFichaElementoCompleto,
        setActualizarFichaElementoCompleto,
        sesionesFicha,
        getSesionesPorConsultante,
        getUsuariosTerapeutasOcupacionales,
        getUsuariosPsicologas,
        getUsuariosOtros,
        usuariosTo,
        usuariosSicologas,
        usuariosOtros,
        insertSesion,
        respuestaIngresoSesion,
        updateRespuestaIngresoSesion,
        deleteFichaConsultanteSesion,
        insertParticipacionGrupal,
        respuestaIngresoParticipacionGrupal,
        updateRespuestaIngresoParticipacionGrupal,
        deleteFichaConsultanteParticipacionGrupal,
        getParticipacionGrupalPorConsultante,
        participacionGrupalFicha
      
    }
}
